import type { UpdateUserGroupMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

type UpdateUserGroupInput = {
  Id: string;
  OriginalTimestamp: string;
  Name?: string;
  Email?: string | null;
  Description?: string | null;
  OwnerContributor?: boolean;
};

const mapTrpcResponseToGraphQL = (): UpdateUserGroupMutation => ({
  update_user_group: {
    __typename: 'user_group_mutation_response',
    affected_rows: 1,
  },
});

export const useUpdateUserGroupTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.userGroup.update.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.userGroup.userGroupsWithApprovers.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.userGroup.userGroupById.queryKey(),
        });
      },
    }),
  });

  return {
    updateUserGroup: async (
      variables: UpdateUserGroupInput
    ): Promise<UpdateUserGroupMutation> => {
      await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL();
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
